import initialState from './initialState';
import Immutable from 'seamless-immutable';
import { types } from '../actions/paymentCardActions';
import { PaymentCardModel } from '../models/PaymentCardModel';

export default function paymentCardReducer(state = Immutable(initialState.paymentCard), action) {
  switch (action.type) {
    case types.GET_PAYMENT_CARD:
      return state.merge({ fetching: true, error: null });
    case types.GET_PAYMENT_CARD_SUCCESS:
      return state.merge({
        fetching: false,
        error: null,
        data: new PaymentCardModel(action.data),
      });
    case types.GET_PAYMENT_CARD_FAILURE:
      return state.merge({ fetching: false, error: true });
    case types.START_PAYMENT_CARD_ACTIVATION:
    case types.RESUME_PAYMENT_CARD_ACTIVATION:
    case types.DEACTIVATE_PAYMENT_CARD:
      return state.merge({ actionInProgress: true, error: null });
    case types.START_PAYMENT_CARD_ACTIVATION_SUCCESS:
    case types.RESUME_PAYMENT_CARD_ACTIVATION_SUCCESS:
    case types.DEACTIVATE_PAYMENT_CARD_SUCCESS:
      return state.merge({ actionInProgress: false, error: null });
    case types.START_PAYMENT_CARD_ACTIVATION_FAILURE:
    case types.RESUME_PAYMENT_CARD_ACTIVATION_FAILURE:
    case types.DEACTIVATE_PAYMENT_CARD_FAILURE:
      return state.merge({ actionInProgress: false, error: true });
    default:
      return state;
  }
}
